import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {BaseModal} from '@ui-app/modals/base-modal';
import {BehaviorSubject} from 'rxjs';
import {map} from 'rxjs/operators';
import * as EmployeeModels from '@employee-models/index';
import {IRejectedReasonPayloadData} from '@employee-models/common.models';
import {StaticDataService} from '../../core/services/data-access/static-data-service';


interface IRejectedReasonsOptionsList extends EmployeeModels.DM.IRejectedPhotoReasonModel {
    isExcluded?: boolean;
    isChecked?: boolean;
}

@Component({
  selector: 'employee-photo-cancel-modal',
  templateUrl: './prehirephoto-cancel-modal.component.html',
  styleUrls: ['./prehirephoto-cancel-modal.component.less']
})
export class PrehirePhotoCancelModalComponent extends BaseModal implements OnInit {


    @Input() buttonsTitle  = {
        dismiss: 'Cancel',
        confirm: 'Submit'
    };
    @Input() textAreaCharLimit = 200;

    text = 'This action will cancel the request, with an option to create a new request. Do you wish to proceed?';    
    payload: {value: boolean};

    constructor(private staticDataService: StaticDataService) {
        super();
    }

    ngOnInit(): void {
        
    }

    submit(): void {
        this.payload = {
          value:true
        };
        this.action(this.payload);
    }

    
}
